export default __webpack_public_path__ + "static/cats-22da2f5724d28765d21406065d6e5e74.jpg";